import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { selectAccessoryProducts } from 'shared/product_tabs/tab_accessories/slice/selectors';
import {
  changeAccessoryQuantity,
  changeAccessorySelected,
  changeAccessoryVariant,
} from 'shared/product_tabs/tab_accessories/slice/accessoriesSlice';

import Accessory from 'shared/product_tabs/tab_accessories/components/Accessory';

const Accesories = () => {
  const dispatch = useDispatch();

  const {
    paste_products,
    other_products,
  } = useSelector(selectAccessoryProducts);

  const onChangeQuantity = (index, quantity) => {
    dispatch(changeAccessoryQuantity({ index, quantity }));
  };

  const onChangeVariant = (index, variant) => {
    dispatch(changeAccessoryVariant({ index, variant }));
  };

  const onSelect = (index) => {
    dispatch(changeAccessorySelected({ index }));
  };

  return (
    <>
      <div className="d-flex align-items-md-center select-paragraph spacing-1">
        <FontAwesomeIcon
          style={{ color: '#267cd2' }}
          className="mt-1 mt-md-0 mb-1"
          icon="fa-solid fa-caret-right" />
        <h6 className="select-title mb-0">
          &nbsp;
          To select an item please click the checkbox and enter a quantity
        </h6>
      </div>
      <div className="row">
        {paste_products.map((accessory, idx) => (
          <div key={`paste-product-${idx}`} className="col-12 col-md-6 col-lg-3 my-3">
            <Accessory
              accessory={accessory}
              accessoryClassName="paste-item"
              onChangeQuantity={onChangeQuantity}
              onChangeVariant={onChangeVariant}
              onSelect={onSelect} />
          </div>
        ))}
      </div>
      {other_products.length > 0 && (
        <>
          <div className="d-flex align-items-center select-paragraph spacing-2">
          <FontAwesomeIcon
            style={{ color: '#267cd2' }}
            className="mt-1 mt-md-0 mb-1"
            icon="fa-solid fa-caret-right" />
          <h6 className="select-title mb-0">
            &nbsp;
            If you are interested please select other accessories
          </h6>
          </div>
          <div className="row">
            {other_products.map((accessory, idx) => (
              <div key={`other-product-${idx}`} className="col-12 col-md-6 col-lg-3 my-3">
                <Accessory
                  accessory={accessory}
                  accessoryClassName="other-item"
                  onChangeQuantity={onChangeQuantity}
                  onChangeVariant={onChangeVariant}
                  onSelect={onSelect} />
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default Accesories;
